<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DIRF -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-k-v
                            titulo="Data da Importação"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.dataCadastro"
                        ></app-k-v>
                        <app-k-v
                            titulo="Ano Referência"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.anoReferencia"
                        ></app-k-v>
                        <app-k-v
                            titulo="Ano Calendário"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.anoCalendario"
                        ></app-k-v>
                        <app-k-v
                            titulo="Retificadora"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.retificadora == 'S' ? 'SIM' : 'NÃO'"
                        ></app-k-v>
                        <app-k-v
                            titulo="CNPJ Fonte Pagadora"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.cnpj"
                        ></app-k-v>
                        <app-k-v
                            titulo="Fonte Pagadora"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.nomePagadora"
                        ></app-k-v>
                        <app-k-v
                            titulo="CPF Responsável"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.cpfResponsavel"
                        ></app-k-v>
                        <app-k-v
                            titulo="Nome Responsável"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.nomeResponsavel"
                        ></app-k-v>
                        <app-k-v
                            titulo="Email Responsável"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="dirf.email"
                        ></app-k-v>
                        <dirf-beneficiario :beneficiario="beneficiario" v-if="mostrarBeneficiario"></dirf-beneficiario>
                    </b-card-body>
                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                            <span>
                                <i class="fa fa-history"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-show="mostrarBeneficiarios">
            <b-col sm="12">
                <dirf-beneficiarios :beneficiarios="dirf.beneficiarios"></dirf-beneficiarios>
            </b-col>
        </b-row>
        <b-row v-if="mostrarBeneficiario">
            <b-col sm="12" md="6">
                <rendimentos
                    :dirfBeneficiarioId="beneficiario.dirfBeneficiarioId"
                    :beneficiario="beneficiario.nome"
                    :anoCalendario="dirf.anoCalendario"
                    :rendimentos="valores.rendimentos"
                    :dirfsServicos="obterDirfsServicos()"
                ></rendimentos>
            </b-col>
            <b-col sm="12" md="6">
                <pagamentos
                    :dirfBeneficiarioId="beneficiario.dirfBeneficiarioId"
                    :beneficiario="beneficiario.nome"
                    :anoCalendario="dirf.anoCalendario"
                    :pagamentos="valores.pagamentos"
                    :dirfsServicos="obterDirfsServicos()"
                ></pagamentos>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import DirfsServicos from './DirfsServicos'
import DirfBeneficiarios from './DirfBeneficiarios'
import DirfBeneficiario from './DirfBeneficiario'
import Pagamentos from './Pagamentos'
import Rendimentos from './Redimentos'

export default {
	components: {
		DirfBeneficiarios,
		DirfBeneficiario,
		Pagamentos,
		Rendimentos
	},

	data() {
		return {
			dirf: {},
			beneficiario: {},
			operacao: 'DETALHAR',
			erros: [],
			valores: {}
		}
	},

	methods: {
		voltar() {
			if (this.$route.name == 'Dirfs_Detalhar') {
				this.$router.push({ name: 'Dirfs' })
			} else if (this.$route.name == 'Dirfs_Detalhar_Beneficiario') {
				this.$router.push({
					name: 'Dirfs_Detalhar',
					params: {
						dirfId: this.$route.params.dirfId
					}
				})
			}
		},

		obterDirf() {
			this.$store.dispatch('addRequest')
			DirfsServicos.obterPorId(this.$route.params.dirfId).then(
				response => {
					if (response) {
						if (response.success) {
							this.dirf = response.data
							this.normalizarDirf()
						} else {
							this.erros = response.errors
						}
					}
					this.$store.dispatch('removeRequest')
				}
			)
		},

		obterValores() {
			this.$store.dispatch('addRequest')
			DirfsServicos.obterValores(
				this.$route.params.dirfBeneficiarioId
			).then(response => {
				if (response) {
					if (response.success) {
						this.valores = response.data
					} else {
						this.erros = response.errors
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		normalizarDirf() {
			this.dirf.dataCadastro = this.$maskDateTime(this.dirf.dataCadastro)
			this.dirf.cnpj = this.$maskCpfCnpj(this.dirf.cnpj)
			this.dirf.cpfResponsavel = this.$maskCpfCnpj(
				this.dirf.cpfResponsavel
			)
			if (this.$route.name == 'Dirfs_Detalhar_Beneficiario') {
				this.selecionaBeneficiario()
				this.obterValores()
			}
		},

		detalharBeneficiario(dirfBeneficiarioId) {
			this.beneficiario
		},

		selecionaBeneficiario() {
			return (this.beneficiario = this.dirf.beneficiarios.filter(item => {
				return (
					item.dirfBeneficiarioId ==
					this.$route.params.dirfBeneficiarioId
				)
			})[0])
		},

		obterDirfsServicos() {
			return DirfsServicos
		}
	},

	computed: {
		mostrarBeneficiarios() {
			return this.$route.name == 'Dirfs_Detalhar'
		},

		mostrarBeneficiario() {
			return this.$route.name == 'Dirfs_Detalhar_Beneficiario'
		}
	},

	created() {
		if (this.$route.name == 'Dirfs_Detalhar' || _.isEmpty(this.dirf)) {
			this.obterDirf()
		}
	},

	watch: {
		$route(to, from) {
			if (to.name === 'Dirfs_Detalhar_Beneficiario') {
				this.selecionaBeneficiario()
				this.obterValores()
			}
		}
	}
}
</script>
